"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = exports.ModalVariants = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const get_1 = __importDefault(require("lodash/get"));
const react_intl_1 = require("react-intl");
const ThemeProvider_1 = require("../../utils/ThemeProvider");
const Utils_1 = require("../../utils/Utils");
const icons_1 = require("../../assets/icons");
const StyleUtils_1 = require("../../utils/StyleUtils");
const ModalProvider_1 = require("./ModalProvider");
const Modal_styles_1 = require("./styles/Modal.styles");
const __DEV__ = process.env.NODE_ENV !== 'production';
var ModalVariants;
(function (ModalVariants) {
    ModalVariants["DEFAULT"] = "default";
    ModalVariants["SMALL"] = "small";
    ModalVariants["LARGE"] = "large";
    ModalVariants["FULL_SCREEN"] = "fullScreen";
})(ModalVariants = exports.ModalVariants || (exports.ModalVariants = {}));
const Modal = (props) => {
    const { children, id, testId, className = '', allowMaskClose = true, variant = ModalVariants.DEFAULT, maskBackgroundColor, contentBackgroundColor, showCloseIcon = true, fadeIn = true, minHeight, } = props;
    const theme = (0, ThemeProvider_1.useTheme)();
    const { removeModal } = (0, ModalProvider_1.useModals)();
    const intl = (0, react_intl_1.useIntl)();
    const [shouldFadeIn, setShouldFadeIn] = (0, react_1.useState)(false);
    const [visible, setVisible] = (0, react_1.useState)(false);
    if (!theme) {
        if (__DEV__) {
            console.error('`Modal` component must be a child of a `ThemeProvider`');
        }
        return null;
    }
    if (!intl) {
        if (__DEV__) {
            console.error('`Modal` component must be a child of a `IntlProvider`');
        }
        return null;
    }
    if (!removeModal) {
        if (__DEV__) {
            console.error('`Modal` component must be a child of a `ModalProvider`');
        }
        return null;
    }
    let modalStyles = theme.variants.modals.default;
    const modalVariantStyles = (0, get_1.default)(theme.variants.modals, variant);
    if (!modalVariantStyles) {
        if (__DEV__) {
            console.error(`Could not find modal variant 'modals.${variant}'. Falling back to default modal styles.`);
        }
    }
    else {
        modalStyles = Object.assign(Object.assign({}, modalStyles), modalVariantStyles);
    }
    const maskRef = (0, react_1.useRef)();
    const styles = (0, Modal_styles_1.getModalStyles)({ styles: modalStyles, maskBackgroundColor, contentBackgroundColor, minHeight });
    const dti = (0, Utils_1.getTestIdAttribute)(testId);
    const handleEscPress = (e) => {
        const isEscKey = e.key === 'Escape';
        if (allowMaskClose && isEscKey)
            removeModal(id);
    };
    const handleMaskClose = (e) => {
        const isMaskContainer = e.target === maskRef.current;
        if (allowMaskClose && isMaskContainer)
            removeModal(id);
    };
    const handleClose = () => {
        removeModal(id);
    };
    (0, react_1.useEffect)(() => {
        // Animations
        setTimeout(() => {
            if (fadeIn)
                setShouldFadeIn(true);
            else
                setVisible(true);
        }, 0);
        document.addEventListener('keydown', handleEscPress);
        // cleanup
        return () => {
            document.removeEventListener('keydown', handleEscPress);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ role: "presentation", ref: maskRef, id: id, className: (0, StyleUtils_1.classNames)('Modal-local', styles.maskContainer, className, shouldFadeIn && styles.fadeIn, visible && styles.visible) }, dti, { onClick: handleMaskClose }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, StyleUtils_1.classNames)('Modal-content-local', styles.mainContainer, shouldFadeIn && styles.fadeIn, visible && styles.visible) }, { children: [showCloseIcon && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, StyleUtils_1.classNames)('Modal-header-local', styles.header) }, { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ onClick: handleClose, "aria-label": intl.formatMessage({
                            id: 'blueprint.modal.close.ariaLabel',
                            defaultMessage: 'Close modal',
                            description: 'Blueprint modal close button aria label',
                        }), className: (0, StyleUtils_1.classNames)('Modal-closeButton-local', styles.closeButton) }, { children: (0, jsx_runtime_1.jsx)(icons_1.CloseIcon, { className: (0, StyleUtils_1.classNames)(styles.icon) }) })) }))), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, StyleUtils_1.classNames)('Modal-mainWrapper-local', styles.mainWrapper) }, { children: children }))] })) })));
};
exports.Modal = Modal;
